<template>
  <div v-loading="loading" class="upload">
    <div v-for="(item, index) in documentType" :key="item.id">
      <UploadList
        :title="`${index + 1}. ${item[`name${$t('message.lan')}`]}`"
        :documentType="item"
        :application="application"
        :serviceType="serviceType"
        @change="handleChange($event, item.id)"
        @removeFile="removeFile(item.id)"
      ></UploadList>
    </div>
    <div class="next_btn">
      <GradientBtn white @click="back">{{ $t("message.back") }}</GradientBtn>
      <GradientBtn @click="next" :disabled="loading">
        {{ $t("message.DataRegistration.upload.next") }}
      </GradientBtn>
    </div>
  </div>
</template>

<script>
import { getDetail } from "@/api/hzmb-gh/HzmbHApplicationApi";
import DocumentTypeAPI from "@/api/hzmb-gh/DocumentTypeAPI";
import GradientBtn from "@/components/GradientBtn";
import UploadList from "./UploadList";

export default {
  components: { UploadList, GradientBtn },
  data() {
    return {
      serviceType: null,
      loading: false,
      application: {},
      verifyForm: {},
      documentType: [],
    };
  },
  computed: {
    isFollowing() {
      return this.application.status === "FOLLOWING";
    },
  },
  created() {
    this.getSomething();
  },
  methods: {
    //
    async getSomething() {
      this.loading = true;

      try {
        let { f = "" } = this.$route.query;
        this._verifyForm =
          JSON.parse(localStorage.getItem(`verifyFormH${f}`)) || {};
        let { serviceType, registrationNo, identificationNo } =
          this._verifyForm;
        this.serviceType = serviceType;

        this.application = await getDetail({
          serviceType,
          registrationNo,
          identificationNo,
        });
        this._state = this.application.status;
        this.getDocument();
      } catch (error) {
        this.loading = false;
        this.$error(error);
      }
    },
    //
    async getDocument() {
      this.loading = true;

      try {
        let fileList = await DocumentTypeAPI.get(this.serviceType);
        let { documents = [], supplementDocuments = [] } = this.application;

        fileList = fileList
          .map((item) => {
            let findDoc = documents.find(
              (file) => file.documentType.id === item.id
            );
            let findSupDoc = supplementDocuments.find(
              (file) => file.documentType.id === item.id
            );

            if (this.isFollowing) {
              if (!findSupDoc) {
                return null;
              } else if (findDoc) {
                return {
                  ...item,
                  file: {
                    name: findDoc.file.filename,
                    size: findDoc.file.fileSize,
                  },
                  supplementReason: findSupDoc.supplementReason,
                  document: findDoc,
                };
              } else {
                return {
                  ...item,
                  supplementReason: findSupDoc.supplementReason,
                };
              }
            } else {
              if (findDoc) {
                return {
                  ...item,
                  file: {
                    name: findDoc.file.filename,
                    size: findDoc.file.fileSize,
                  },
                  document: findDoc,
                };
              } else {
                return item;
              }
            }
          })
          .filter((item) => item);

        this.documentType = fileList;
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    //
    handleChange(file, id) {
      this.documentType = this.documentType.map((item) => {
        if (item.id == id) {
          item.file = file;
        }
        return item;
      });
    },
    // 移除文件
    removeFile(id) {
      this.documentType = this.documentType.map((item) => {
        if (item.id == id) {
          delete item.file;
        }
        return item;
      });
    },
    //
    async next() {
      // 驗證必填項
      let isError = this.documentType.some((item) => {
        if (item.required && !item.file) return true;
        return false;
      });

      if (isError) {
        this.$message({
          type: "error",
          message: this.$t("message.upload_required"),
        });
        return false;
      }

      this.$router.push({
        name: "hzmbHFirstCheck",
        query: { ...this.$route.query },
      });
    },
    //
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  max-width: 690px;
  min-height: 500px;
  margin: 24px auto;
  background: #fff;
  overflow: hidden;
  padding-left: 14px;
  padding-right: 14px;
}
</style>
